import { alpha } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const paperStyles = {
  p: 4,
  mt: 2,
  position: 'relative',
  height: 'calc(65vh / var(--zoom) - 65px)',
  background: abyssColors.neutral[50],
  border: `1px solid ${alpha('#6e8198', 0.25)}`,
};

export const feedbackCircleStyles = {
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  justifyContent: 'center',
  '& .MuiTypography-root': {
    marginTop: '10px',
    fontSize: '1.4rem',
  },
};

export const textStyles = {
  font: 'Roboto',
  fontWeight: '400',
  color: '#425265',
  textAlign: 'center',
};

export const buttonStyles = {
  position: 'absolute',
  m: 3,
  right: 10,
  bottom: 3,
};

export const textFieldStyles = {
  width: '100%',
};

export const radioButtonStyles = {
  width: '100%',
  gap: '4px',
  '& label': {
    fontSize: '1.2rem',
    color: alpha('#000', 0.6),
  },
  '& .MuiFormControlLabel-root': {
    marginLeft: '-4px',
    marginRight: '24px',
  },
  '& .MuiSvgIcon-root': {
    color: '#0288D1',
  },
  '& .MuiTypography-root': {
    fontSize: '1.2rem',
  },
};
